<template>
     <!-- 选择cuisine -->
    <el-dialog
    title="Select a cuisine"
    :visible.sync="cuisineDio"
    :modal-append-to-body="false"
    :show-close='false'
    class="cuisineDio"
    :close-on-click-modal='false'
    width="840px"
    center>
        <div>
            <el-input v-model="cuisineSearch" placeholder="Start typing to search…" @input="search" class="venueInformation_input"></el-input>
            <div class="cuisineMsg_box">
                <scroll>
                    <ul class="cuisineMsg_box_ul">
                        <li  class="cuisineMsg_box_li" 
                        :class="{'checked':isContains(item,cuisineListChecked)}" 
                        @click="selectCuis(item)"
                        v-for="(item,i) in cuisineListShow" :key="i">
                            {{item}} 
                        </li>
                    </ul>
                </scroll>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close" class="cardCanBtn">Cancel</el-button>
            <el-button @click="addCuisin" class="cardConBtn">Add</el-button>
        </span>
    </el-dialog>
</template>

<script>
import scroll from './scroll.vue'
export default {
    name:'cuisineDio',
    props:['cuisineDio','cuisineListCheckF'],
    components:{scroll},
    data() {
        return {
            cuisineSearch:'', // 选项搜索关键字
            cuisineList:[ // 选项源数据
                'Afghan',
                'African',
                'American',
                'Arabian',
                'Argentine',
                'Asian',
                'Asian Fusion',
                'Australian',
                'Austrian',
                'BBQ',
                'Bakery',
                'Bangladeshi',
                'Bar Food',
                'Basque',
                'Belgian',
                'Beverages',
                'Brazilian',
                'British',
                'Bubble Tea',
                'Burger',
                'Burmese',
                'Cabinet Food',
                'Cafe Food',
                'Cambodian',
                'Cantonese',
                'Caribbean',
                'Charcoal Chicken',
                'Chinese',
                'Coffee and Tea',
                'Colombian',
                'Contemporary',
                'Continental',
                'Creole',
                'Crepes',
                'Croatian',
                'Danish',
                'Deli',
                'Desserts',
                'Drinks Only',
                'Dumplings',
                'Dutch',
                'Eastern European',
                'Egyptian',
                'Ethiopian',
                'European',
                'Falafel',
                'Filipino',
                'Finger Food',
                'Fish and Chips',
                'French',
                'Fried Chicken',
                'Frozen Yogurt',
                'Fusion',
                'Georgian',
                'German',
                'Greek',
                'Grill',
                'Hawaiian',
                'Healthy Food',
                'Hot Pot',
                'Hungarian',
                'Ice Cream',
                'Indian',
                'Indonesian',
                'International',
                'Iranian',
                'Iraqi',
                'Irish',
                'Israeli',
                'Italian',
                'Japanese',
                'Japanese BBQ',
                'Jewish',
                'Juices',
                'Kebab',
                'Korean',
                'Korean BBQ',
                'Latin American',
                'Lebanese',
                'Malatang',
                'Malaysian',
                'Mauritian',
                'Meat Pie',
                'Mediterranean',
                'Mexican',
                'Middle Eastern',
                'Modern Australian',
                'Modern European',
                'Mongolian',
                'Moroccan',
                'Nepalese',
                'North Indian',
                'Pacific',
                'Pakistani',
                'Pan Asian',
                'Parma',
                'Pastry',
                'Patisserie',
                'Peruvian',
                'Pho',
                'Pizza',
                'Poké',
                'Polish',
                'Portuguese',
                'Pub Food',
                'Ramen',
                'Roast',
                'Russian',
                'Salad',
                'Sandwich',
                'Satay',
                'Scandinavian',
                'Scottish',
                'Seafood',
                'Shanghai',
                'Sichuan',
                'Singaporean',
                'Soul Food',
                'South African',
                'South Indian',
                'Spanish',
                'Sri Lankan',
                'Steak',
                'Street Food',
                'Sushi',
                'Swedish',
                'Swiss',
                'Syrian',
                'Taiwanese',
                'Tapas',
                'Tea',
                'Teppanyaki',
                'Teriyaki',
                'Tex-Mex',
                'Thai',
                'Tibetan',
                'Turkish',
                'Ukrainian',
                'Uruguayan',
                'Uyghur',
                'Vegan',
                'Vegetarian',
                'Venezuelan',
                'Vietnamese',
                'Yum Cha',
            ],
            cuisineListChecked:[], // 选项选中数据，未b保存
        }
    },
    computed:{
        cuisineListShow(){
            return this.cuisineDio?this.cuisineList:[]
        }
    },
    mounted() {
        this.cuisineListChecked = this.cuisineListCheckF
    },
    methods: {
        close(){
            this.cuisineSearch=''
            this.cuisineListChecked=[]
            this.$emit('close')
        },
        search(){ // 搜索选项
            const filtList=Object.assign(this.cuisineList,{})
            let arr=filtList.filter(item=>{
                return (item.toLowerCase()).indexOf((this.cuisineSearch.toLowerCase()))!=-1
            })
            this.cuisineListShow=arr
        },
        selectCuis(item){ // 选中 or 取消 
            if(!this.isContains(item,this.cuisineListChecked)){
                if(this.cuisineListChecked.length<10){
                    this.cuisineListChecked.push(item)
                }else{
                    this.$message.error('A maximum of 10 can be added')
                }
            }else{
                let ii=this.cuisineListChecked.findIndex(val=>val==item)
                if(ii>=0){
                    this.cuisineListChecked.splice(ii,1)
                }
            }
        },
        addCuisin(){ // 添加选项
            this.$emit('addCuisin',this.cuisineListChecked)
            this.cuisineListChecked=[]
        },
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/common/cuisineDio.vue